import React from 'react';
import styles from './Container.module.css';

const Container = ({ 
  children, 
  size = 'lg',
  className = '',
  ...props 
}) => {
  const containerClasses = [
    styles.container,
    styles[size],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...props}>
      {children}
    </div>
  );
};

export default Container;